<div class="mb-3">

  <label *ngIf="label" class="form-label">
    {{ label }}
    <span *ngIf="required" class="text-danger ms-1">*</span>
  </label>

  <div class="position-relative">

    <!-- Prefix icon -->
    <span *ngIf="prefixIcon" class="is-input-field__prefix position-absolute top-50 translate-middle-y">
      <i [class]="'bx ' + prefixIcon + ' text-muted'"></i>
    </span>

    <input
      [type]="inputType"
      [ngClass]="inputClasses"
      [placeholder]="placeholder"
      [disabled]="isDisabled"
      [readonly]="readonly"
      [value]="value"
      (input)="handleInput($event)"
      (blur)="handleBlur()"
    >

    <!-- Password toggle -->
    <button
      *ngIf="type === 'password'"
      type="button"
      class="btn btn-link is-input-field__toggle position-absolute top-50 end-0 translate-middle-y pe-3 text-muted"
      (click)="togglePasswordVisibility()"
      tabindex="-1"
      [attr.aria-label]="showPassword ? 'Ocultar senha' : 'Mostrar senha'"
    >
      <i [class]="'bx ' + (showPassword ? 'bx-hide' : 'bx-show')"></i>
    </button>

    <!-- Suffix icon (non-password) -->
    <span
      *ngIf="suffixIcon && type !== 'password'"
      class="is-input-field__suffix position-absolute top-50 end-0 translate-middle-y pe-3"
    >
      <i [class]="'bx ' + suffixIcon + ' text-muted'"></i>
    </span>

  </div>

  <small *ngIf="helpText && !hasError" class="form-text text-muted">{{ helpText }}</small>

  <is-form-error *ngIf="control" [control]="control"></is-form-error>

</div>
